import { BRAND } from "@/constants/testIds";
import { cn } from "@/lib/utils";

/**
 * Placeholder wordmark for Casino Tampiqueño · CT Connect.
 * Typographic identity until an official logo is provided.
 */
export const Brand = ({ variant = "full", className }) => {
  return (
    <div
      className={cn("inline-flex items-center gap-3 select-none", className)}
      data-testid={BRAND.wordmark}
    >
      <div
        data-testid={BRAND.mark}
        className={cn(
          "grid place-items-center rounded-xl bg-primary text-primary-foreground",
          "w-10 h-10 shadow-soft ring-1 ring-accent/40",
        )}
      >
        <span className="font-heading text-lg leading-none tracking-tight">
          CT
        </span>
      </div>
      {variant === "full" && (
        <div className="flex flex-col leading-tight">
          <span className="font-heading text-lg text-foreground">
            CT Connect
          </span>
          <span className="overline text-muted-foreground">
            Casino Tampiqueño
          </span>
        </div>
      )}
    </div>
  );
};

export default Brand;
